import MembershipIcon from '~/components/common/MembershipIcon'
import type { Order } from '~/types'

interface OrderMembershipIconProps {
  className?: string
  order: Order
}

const OrderMembershipIcon = ({
  className,
  order,
}: OrderMembershipIconProps) => {
  if (!order.cover) {
    return null
  }

  return <MembershipIcon className={className} limitReached={order.charge} />
}

export default OrderMembershipIcon
